<template>
  <div>
    <section class="xlrclh">
      <img class="top-img" src="./../assets/imgs/111/title-bg.png" alt="" />
      <div class="technological-process">
        <div class="zccl">
          <img class="top" src="./../assets/imgs/111/title-1.png" alt="" />
          <div class="content">

            <div class="des" style="font-weight: normal;">
              <div class="title" style="font-weight: bold;">
                <div class="circle"></div>
                （一）“津领”补贴
              </div>
              <span
                style="font-weight: bold;">政策内容：</span>对新引育的数字经济领域行业领军、资深领航、技术领衔人才，在津从事全职工作、服务期限不低于3年，分别给予200万元、80万元、30万元的奖励，按4:3:3比例分3年兑现。
            </div>
            <div class="des" style="font-weight: normal;margin-top: 0.22rem;">
              <span style="font-weight: bold;">申报条件：</span>1.通过评审委员会认定的人才；2.与企业签订3年及以上劳动合同、个税在新津解缴、在津工作满6个月及以上。
            </div>
            <div class="des" style="font-weight: normal;margin-top: 0.22rem;">
              <span
                style="font-weight: bold;">特别提醒：</span>政策申报按《成都市新津区“津领”人才评选认定办法》文件执行。
            </div>
            <div class="des" style="font-weight: normal;margin-top: 0.22rem;">
              <span
                style="font-weight: bold;">申报渠道：</span>1.由企业填写《成都市新津区支持数字经济青年人才发展十条政策申请表》并向所在产业功能区提交上述材料（纸质版和电子版）；2.受理单位：产业功能区；3.审核单位：区新科局。
            </div>
            <div class="des" style="font-size: 0.3rem; display: flex;margin-top: 0.22rem;">
              <div>咨询电话：新津区新科局 </div>
              <div style="margin-left: 0.2rem;"> <a href="tel:028-67775568">67775568</a></div>
            </div>
            <div class="des" style="font-weight: normal;">
              <div class="title" style="font-weight: bold;">
                <div class="circle"></div>
                （二）研学补贴
              </div>
              <span
                style="font-weight: bold;">政策内容：</span>支持数字领域相关专业学生到新津开展研学活动，经备案的，可为其提供车辆、住宿、用餐等保障，对参与学生给予每人200元/天补贴，每人每年不超过3000元。
            </div>
            <div class="des" style="font-weight: normal;margin-top: 0.22rem;">
              <span style="font-weight: bold;">申报条件：</span>1.符合数字领域相关专业的高校和职业技术（技工）院校学生；2.通过团区委备案的各类研学活动。
            </div>
            <div class="des" style="font-weight: normal;margin-top: 0.22rem;">
              <span style="font-weight: bold;">特别提醒：</span>申报时学生需提供学信网学籍证明、研学方案、照片等。
            </div>
            <div class="des" style="font-weight: normal;margin-top: 0.22rem;">
              <span style="font-weight: bold;">申报渠道：</span>由团区委按研学批次统一填写《成都市新津区支持数字经济青年人才发展十条政策申请表》并审核上述材料（纸质版和电子版）。
            </div>
            <div class="des" style="font-size: 0.3rem; display: flex;margin-top: 0.22rem;">
              <div>咨询电话：团新津区委 </div>
              <div style="margin-left: 0.2rem;"> <a href="tel:028-82530667">82530667</a></div>
            </div>
            <div class="des" style="font-weight: normal;">
              <div class="title" style="font-weight: bold;">
                <div class="circle"></div>
                （三）实习补贴
              </div>
              <span
                style="font-weight: bold;">政策内容：</span>鼓励数字领域相关专业学生到新津实习见习，按每月1500元/人标准给予学生补贴，每人每年不超过4500元。
            </div>
            <div class="des" style="font-weight: normal;margin-top: 0.22rem;">
              <span style="font-weight: bold;">申报条件：</span>1.符合数字领域相关专业的高校和职业技术（技工）院校学生；2.签订实习见习协议（实习见习至少1个月）；3.实习见习原则上至少1月起算，按整月申报。
            </div>
            <div class="des" style="font-weight: normal;margin-top: 0.22rem;">
              <span style="font-weight: bold;">特别提醒：</span>申报时学生需提供学生证或者毕业证、学位证、实习见习协议等。
            </div>
            <div class="des" style="font-weight: normal;margin-top: 0.22rem;">
              <span style="font-weight: bold;">申报渠道：</span>1.由企业填写《成都市新津区支持数字经济青年人才发展十条政策申请表》并向所在产业功能区提交上述材料（纸质版和电子版）；2.受理单位：产业功能区；3.审核单位：团区委。
            </div>
            <div class="des" style="font-size: 0.3rem; display: flex;margin-top: 0.22rem;">
              <div>咨询电话：团新津区委   </div>
              <div style="margin-left: 0.2rem;"> <a href="tel:028-82530667">82530667</a></div>
            </div>
            <div class="des" style="font-weight: normal;">
              <div class="title" style="font-weight: bold;">
                <div class="circle"></div>
                （四）入职补贴
              </div>
              <span
                style="font-weight: bold;">政策内容：</span>对新引进的数字经济青年人才，签订3年以上劳动合同，且在津工作满一年的，按年薪10%的标准，给予最高10万元的一次性就业补贴。
            </div>
            <div class="des" style="font-weight: normal;margin-top: 0.22rem;">
              <span style="font-weight: bold;">申报条件：</span>1.入选新津数字经济企业和实行智能化改造的传统企业名单中的从事数字经济领域全职工作的数字经济青年人才；2.签订3年及以上全职工作劳动合同；3.在成都连续缴纳社会保险且在新津连续解缴个人所得税12个月及以上。
            </div>
            <div class="des" style="font-weight: normal;margin-top: 0.22rem;">
              <span style="font-weight: bold;">特别提醒：</span>人才需提供社保、个税证明等。
            </div>
            <div class="des" style="font-weight: normal;margin-top: 0.22rem;">
              <span style="font-weight: bold;">申报渠道：</span>1.由企业填写《成都市新津区支持数字经济青年人才发展十条政策申请表》并向所在产业功能区提交上述材料（纸质版和电子版）；2.受理单位：产业功能区；3.审核单位：区人社局。
            </div>
            <div class="des" style="font-size: 0.3rem; display: flex;margin-top: 0.22rem;">
              <div>咨询电话：新津区人社局   </div>
              <div style="margin-left: 0.2rem;"> <a href="tel:028-82479907">82479907</a></div>
            </div>
            <div class="des" style="font-weight: normal;">
              <div class="title" style="font-weight: bold;">
                <div class="circle"></div>
                （五）培训补贴
              </div>
              <span
                style="font-weight: bold;">政策内容：</span>鼓励数字经济青年人才参加各类数字经济领域培训和行业大赛等，分别按照省外150元/人·天、省内100元/人·天给予参训、参赛人员补贴，每人每年不超过3000元。
            </div>
            <div class="des" style="font-weight: normal;margin-top: 0.22rem;">
              <span style="font-weight: bold;">申报条件：</span>1.入选新津数字经济企业和实行智能化改造的传统企业名单中的从事数字经济领域全职工作的数字经济青年人才；2.签订3年及以上全职工作劳动合同；3.在成都连续缴纳社会保险且在新津连续解缴个人所得税6个月及以上；4.参加数字经济领域培训和行业大赛等。
            </div>
            <div class="des" style="font-weight: normal;margin-top: 0.22rem;">
              <span style="font-weight: bold;">特别提醒：</span>需准备培训通知（协议）、参赛通知、培训（参赛）照片、差旅、培训票据等。
            </div>
            <div class="des" style="font-weight: normal;margin-top: 0.22rem;">
              <span style="font-weight: bold;">申报渠道：</span>1.由企业填写《成都市新津区支持数字经济青年人才发展十条政策申请表》并向所在产业功能区提交上述材料（纸质版和电子版）；2.受理单位：产业功能区；3.审核单位：区人社局。
            </div>
            <div class="des" style="font-size: 0.3rem; display: flex;margin-top: 0.22rem;">
              <div>咨询电话：新津区人社局 </div>
              <div style="margin-left: 0.2rem;"> <a href="tel:028-82556991">82556991</a></div>
            </div>
            <div class="des" style="font-weight: normal;">
              <div class="title" style="font-weight: bold;">
                <div class="circle"></div>
                （六）创业补贴
              </div>
              <span
                style="font-weight: bold;">政策内容：</span>支持数字经济青年人才创业，对获得风险投资的，按照股权融资额的10%给予最高50万元的启动资金支持；对数字经济青年人才（团队）作为实际控制人的区内数字企业获得创投机构股权投资的，区科技创新引导资金建立的子基金可给予不高于20%的跟投。
            </div>
            <div class="des" style="font-weight: normal;margin-top: 0.22rem;">
              <span style="font-weight: bold;">申报条件：</span>1.入选新津数字经济企业和实行智能化改造的传统企业名单；2.注册地税收及统计关系在新津的企业，且在津注册一年及以上；3.2022年1月1日后获得经证监会或中基协备案的各类风险投资机构股权投资（并购重组、原股东增资、明股实债除外）；4.创办者个人或团队在企业持有股份不低于30%；5.实际控制人在新津连续缴纳6个月以上社保和个税；6.通过政府性投资基金管理机构审核。
            </div>
            <div class="des" style="font-weight: normal;margin-top: 0.22rem;">
              <span style="font-weight: bold;">特别提醒：</span>需提供创业个人或团队持股证明等。
            </div>
            <div class="des" style="font-weight: normal;margin-top: 0.22rem;">
              <span style="font-weight: bold;">申报渠道：</span>1.由企业填写《成都市新津区支持数字经济青年人才发展十条政策申请表》并向所在产业功能区提交上述材料（纸质版和电子版）；2.受理单位：产业功能区；3.审核单位：区财金局负责对风险投资机构的投资情况进行认定；区新科局负责跟投相关事宜。
            </div>
            <div class="des" style="font-size: 0.3rem; margin-top: 0.22rem;">
              <div style="display: flex;">
                <div>咨询电话：新津区财金局   </div>
              <div style="margin-left: 0.2rem;"> <a href="tel:028-82526025">82526025</a></div>
              </div>
              <div style="display: flex;">
                <div style="text-indent: 5em;">新津区新科局   </div>
              <div style="margin-left: 0.2rem;"> <a href="tel:028-67775568">67775568</a></div>
              </div>
            </div>
            <div class="des" style="font-weight: normal;">
              <div class="title" style="font-weight: bold;">
                <div class="circle"></div>
                （七）贷款补贴
              </div>
              <span
                style="font-weight: bold;">政策内容：</span>对数字经济青年人才创业获得区内银行贷款的，创办者个人或团队在企业持有股份不低于30%，贷款50万元以下的部分，给予最高50%贴息，贴息时间不超过3年。
            </div>
            <div class="des" style="font-weight: normal;margin-top: 0.22rem;">
              <span style="font-weight: bold;">申报条件：</span>1.入选新津数字经济企业和实行智能化改造的传统企业名单；2.2022年1月1日后获得区内非政策性银行贷款；3.创办者个人或团队在企业持有股份不低于30%；4.每年申报前一年度资金。
            </div>
            <div class="des" style="font-weight: normal;margin-top: 0.22rem;">
              <span style="font-weight: bold;">特别提醒：</span>需提供创业个人或团队持股证明等。
            </div>
            <div class="des" style="font-weight: normal;margin-top: 0.22rem;">
              <span style="font-weight: bold;">申报渠道：</span>1.由企业填写《成都市新津区支持数字经济青年人才发展十条政策申请表》并向所在产业功能区提交上述材料（纸质版和电子版）；2.受理单位：产业功能区；3.审核单位：区财金局。
            </div>
            <div class="des" style="font-size: 0.3rem; display: flex;margin-top: 0.22rem;">
              <div>咨询电话：新津区财金局  </div>
              <div style="margin-left: 0.2rem;"> <a href="tel:028-82526025">82526025</a></div>
            </div>
            <div class="des" style="font-weight: normal;">
              <div class="title" style="font-weight: bold;">
                <div class="circle"></div>
                （八）交通补贴
              </div>
              <span
                style="font-weight: bold;">政策内容：</span>数字经济青年人才在津工作期间，签订3年以上劳动合同，按照0.6万元/人·年的标准给予交通补贴，补贴时间不超过3年。
            </div>
            <div class="des" style="font-weight: normal;margin-top: 0.22rem;">
              <span style="font-weight: bold;">申报条件：</span>1.入选新津数字经济企业和实行智能化改造的传统企业名单中的从事数字经济领域全职工作的数字经济青年人才；2.签订3年及以上全职工作劳动合同；3.在成都连续缴纳社会保险且在新津连续解缴个人所得税12个月及以上。
            </div>
            <div class="des" style="font-weight: normal;margin-top: 0.22rem;">
              <span style="font-weight: bold;">特别提醒：</span>需提供劳动合同复印件；四川省社会保险个人参保证明；个人所得税纳税记录等。
            </div>
            <div class="des" style="font-weight: normal;margin-top: 0.22rem;">
              <span style="font-weight: bold;">申报渠道：</span>1.由企业填写《成都市新津区支持数字经济青年人才发展十条政策申请表》并向所在产业功能区提交上述材料（纸质版和电子版）；2.受理单位：产业功能区；3.审核单位：区人社局。
            </div>
            <div class="des" style="font-size: 0.3rem; display: flex;margin-top: 0.22rem;">
              <div>咨询电话：新津区人社局   </div>
              <div style="margin-left: 0.2rem;"> <a href="tel:028-82479907">82479907</a></div>
            </div>
            <div class="des" style="font-weight: normal;">
              <div class="title" style="font-weight: bold;">
                <div class="circle"></div>
                （九）租房补贴
              </div>
              <span
                style="font-weight: bold;">政策内容：</span>对在津无房的数字经济青年人才，签订3年以上劳动合同，按照0.6万元/人·年的标准给予租房补贴，补贴时间不超过3年，对符合相关条件的，可申请租住政府提供的人才公寓或保障性租赁住房，享受相关安居政策。
            </div>
            <div class="des" style="font-weight: normal;margin-top: 0.22rem;">
              <span style="font-weight: bold;">申报条件：</span>1.入选新津数字经济企业和实行智能化改造的传统企业名单中的从事数字经济领域全职工作的数字经济青年人才；2.签订3年及以上全职工作劳动合同；3.在成都连续缴纳社会保险且在新津连续解缴个人所得税12个月及以上；4.租房补贴按年度申报。
            </div>
            <div class="des" style="font-weight: normal;margin-top: 0.22rem;">
              <span style="font-weight: bold;">特别提醒：</span>需提供租房协议（合同）复印件；在镇（街道）办理的租赁登记备案凭证；在津无房证明等。
            </div>
            <div class="des" style="font-weight: normal;margin-top: 0.22rem;">
              <span style="font-weight: bold;">申报渠道：</span>1.由企业填写《成都市新津区支持数字经济青年人才发展十条政策申请表》并向所在产业功能区提交上述材料（纸质版和电子版）；2.受理单位：产业功能区；3.审核单位：区公园城市局。
            </div>
            <div class="des" style="font-size: 0.3rem; display: flex;margin-top: 0.22rem;">
              <div>咨询电话：新津区公园城市局 </div>
              <div style="margin-left: 0.2rem;"> <a href="tel:028-82518637">82518637</a></div>
            </div>
            <div class="des" style="font-weight: normal;">
              <div class="title" style="font-weight: bold;">
                <div class="circle"></div>
                （十）成家补贴
              </div>
              <span
                style="font-weight: bold;">政策内容：</span>对新引育的在津工作或自主创业的数字经济青年人才，签订3年以上劳动合同，结婚时给予9999元的一次性消费礼包。
            </div>
            <div class="des" style="font-weight: normal;margin-top: 0.22rem;">
              <span style="font-weight: bold;">申报条件：</span>1.入选新津数字经济企业和实行智能化改造的传统企业名单中的从事数字经济领域全职工作的数字经济青年人才；2.签订3年及以上全职工作劳动合同；3.在成都连续缴纳社会保险且在新津连续解缴个人所得税6个月及以上；4.2022年1月1日后登记结婚且限领一次。
            </div>
            <div class="des" style="font-weight: normal;margin-top: 0.22rem;">
              <span style="font-weight: bold;">特别提醒：</span>需准备夫妻双方身份证复印件、结婚证复印件等。
            </div>
            <div class="des" style="font-weight: normal;margin-top: 0.22rem;">
              <span style="font-weight: bold;">申报渠道：</span>1.由企业填写《成都市新津区支持数字经济青年人才发展十条政策申请表》并向所在产业功能区提交上述材料（纸质版和电子版）；2.受理单位：产业功能区；3.审核单位：区民政局。
            </div>
            <div class="des" style="font-size: 0.3rem; display: flex;margin-top: 0.22rem;">
              <div>咨询电话：新津区民政局 </div>
              <div style="margin-left: 0.2rem;"> <a href="tel:028-82516186">82516186</a></div>
            </div>
          </div>
        </div>




        <div class="sbcl">
          <img class="top" src="./../assets/imgs/111/title-2.png" alt="" />
          <div class="content">
            <div class="des">
              <div class="item" style="">
                <div class="line"></div>
                <div class="dot">1</div>
                <div class="label">
                企业登陆新津科创通（http://www.xjkct.com）进行线上申报
                </div>
              </div>
              <div class="item">
                <div class="line"></div>
                <div class="dot">2</div>
                <div class="label">
                  政策申报受理单位、主管部门依次进行线上审核
                </div>
                <div>1.完备性审核</div>
                <div>2.一致性审核</div>
                <div>3.真实性审核</div>
              </div>
              <div class="item">
                <div class="line"></div>
                <div class="dot">3</div>
                <div class="label">
                审核完成出具审核意见
                </div>
              </div>
              <div class="item">
                <div class="line"></div>
                <div class="dot">4</div>

                <div class="label">
                  企业下载并打印政策申报书

                </div>
              </div>
              <div class="item">
                <div class="line" style="height: 120%;"></div>
                <div class="dot">5</div>
                <div class="label">
                  政策申报受理单位、主管部门依次进行线下复核
                </div>
                <div>1.完备性审核</div>
                <div>2.一致性审核</div>
                <div>3.真实性审核</div>
              </div>
              <div class="item">
                <div class="dot">6</div>
                <div class="label">
                  报区委人才工作领导小组

                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="zccl">
          <img class="top" src="./../assets/imgs/111/title-3.png" alt="" />
          <div class="content" style="background:FFF;">
            每年3月、10月，具体申报时间以每年申报通知为准。
          </div>
        </div>

        <div class="codes">
          <div style="display: flex;justify-content: space-between;align-items: center;">
            <img class="code" src="../assets/imgs/111/code1.png" />
          <img class="text" src="../assets/imgs/111/text1.png" />
          </div>
          <div style="display: flex;justify-content: space-between;align-items: center;">
            <img class="code" src="../assets/imgs/111/code2.png" />
          <img class="text" src="../assets/imgs/111/text2.png" />
          </div>
        </div>
      </div>
    </section>
    <!-- <call phone="028-83221725"></call> -->
  </div>
</template>

<script>
import call from "../components/call.vue";
export default {
  data() {
    return {};
  },

  components: {
    call,
  },

  mounted() { },

  methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";

.xlrclh {
  background-color: $base-back;

  .top-img {
    width: 7.26rem;
    height: 5.6rem;
  }

  .technological-process {
    transform: translateY(-2.3rem);


    .zccl {
      position: relative;
      margin-top: 0.22rem;
      font-size: 0.26rem;
      .top {
          width: 7.03rem;
          height: 1.37rem;
          margin-left: -0.18rem;
      }

      .content {
          width: 6.85rem;
          background: #E8EEFF;
          margin: -0.45rem auto 0;
          padding: 0.33rem;
          box-sizing: border-box;
          border-radius: 0rem 0rem 0.26rem 0.26rem;
          padding-top: 0.28rem;

          font-weight: 500;
          text-align: left;
          color: #4e4e4e;

          .des {
              color: #4e4e4e;
              text-align: left;
              background: #ffffff;
              border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
              padding: 0.35rem 0.23rem 0.3rem;
              margin-top: 0.9rem;
              position: relative;
              text-align: left;
              line-height: 0.44rem;
              font-weight: bold;
              color: #333333;
              font-size: 0.28rem;
              .title {
                  position: absolute;
                  top: -0.6rem;
                  left: 50%;
                  transform: translateX(-50%);
                  width: 100%;
                  // height: 0.67rem;
                  font-size: 0.34rem;

                  // border: 1px solid red;
                  display: flex;
                  justify-content: flex-start;
                  align-items: center;
                  .circle{
                    width: 0.22rem;
                    height: 0.22rem;
                    border: 0.06rem solid #FF6D60;
                    border-radius: 50%;
                  }
              }

          }
      }
    }


    .sbcl {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #e8eeff;
        margin: -0.45rem auto 0;
        padding: 0 0.33rem 0.34rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;
        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.1rem 0.23rem 0.3rem;
          position: relative;

          .item {
            margin-top: 0.35rem;
            box-sizing: border-box;
            position: relative;
            padding-left: 0.42rem;
            line-height: 0.44rem;

            .label{
              line-height: 0.44rem;
            font-weight: bold;
            font-size: 0.28rem;
            color:#3D5AA3;
            }

            .line {
              position: absolute;
              width: 0.02rem;
              height: 135%;
              border-left: 0.02rem dashed #739bfe;
              left: 0.1rem;
              top: 0.2rem;
              z-index: 0;

              //   background-color: #739bfe;
            }

            .dot {
              width: 0.39rem;
              height: 0.39rem;
              background-color: #739bfe;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 0.28rem;
              color: #fff;
              border-radius: 50%;
              position: absolute;
              left: -0.1rem;
              top: 0;
              z-index: 9999;
            }
          }
        }
      }
    }


    .codes {
      margin: 0 auto;
      margin-top: 0.25rem;
      width: 6.85rem;
      background: #fff;
      padding: 0.3rem;
      box-sizing: border-box;
      border-radius: 0.26rem;
      padding-top: 0.28rem;
      font-size: 0.26rem;
      font-weight: 500;
      color: #4e4e4e;

      .code {
        width: 2.8rem;
        height: 2.8rem;
      }

      .text {
        width: 2.8rem;
      }
    }
  }
}
</style>
